import { EnumStorageTransactionType } from '@Model';
import { isBeforeTodayInBerlin } from '@utils/berlinDay';

export const MESSAGE_FUTURE = 'Der Buchungszeitpunkt darf nicht in der Zukunft liegen.';
export const MESSAGE_NO_WEIGHT = 'Bitte ein Gewicht angeben.';
export const MESSAGE_NEGATIVE_WEIGHT = 'Das Gewicht darf nicht negativ sein.';
export const MESSAGE_NEGATIVE_COUNT = 'Der gezählte Bestand darf nicht negativ sein.';

export interface BookingInput {
    type: EnumStorageTransactionType;
    quantity: number;
    /** Whether a weight was put in, to tell an Inventur of 0 from an empty field. */
    quantityEntered: boolean;
    occurredAt: string;
}

export interface BookingErrors {
    occurredAt?: string;
    quantity?: string;
}

function quantityError({ type, quantity, quantityEntered }: BookingInput): string | undefined {
    if (type === EnumStorageTransactionType.Stocktaking) {
        if (!quantityEntered) {
            return MESSAGE_NO_WEIGHT;
        }
        return quantity < 0 ? MESSAGE_NEGATIVE_COUNT : undefined;
    }
    if (quantity < 0) {
        return MESSAGE_NEGATIVE_WEIGHT;
    }
    return quantity === 0 ? MESSAGE_NO_WEIGHT : undefined;
}

/** The rules of the booking mask the server repeats, as messages for the fields they belong to. */
// @ai-generated 2026-10-23T15:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function bookingErrors(input: BookingInput, now: Date = new Date()): BookingErrors {
    const errors: BookingErrors = {};
    const occurredAt = new Date(input.occurredAt);
    if (Number.isNaN(occurredAt.getTime()) || occurredAt > now) {
        errors.occurredAt = MESSAGE_FUTURE;
    }
    const quantity = quantityError(input);
    if (quantity) {
        errors.quantity = quantity;
    }
    return errors;
}

/** The errors plus the server's refusal at the weight, and at the Zeitpunkt when it lies before today. */
// @ai-generated 2026-10-23T16:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function withRejection(
    errors: BookingErrors,
    rejection: string | undefined,
    occurredAt: string,
    now: Date = new Date(),
): BookingErrors {
    if (!rejection) {
        return errors;
    }
    return {
        quantity: errors.quantity ?? rejection,
        occurredAt: errors.occurredAt ?? (isBeforeTodayInBerlin(occurredAt, now) ? rejection : undefined),
    };
}
